<template>
  <div class="settle-account-form">
    <el-alert
      :title="$t('settleAccount.tip')"
      type="warning"
      :closable="false"
      style="margin-bottom: 16px"
    />

    <el-form ref="accountForm" :model="accountForm" :rules="accountRules" label-width="130px" style="max-width: 640px">
      <el-form-item :label="$t('settleAccount.storeName')">
        <el-input v-model="accountForm.storeName" disabled />
      </el-form-item>
      <el-form-item :label="$t('settleAccount.ownerName')" prop="ownerName">
        <el-input v-model="accountForm.ownerName" :placeholder="$t('settleAccount.ownerNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('settleAccount.bankName')" prop="bankName">
        <el-input v-model="accountForm.bankName" :placeholder="$t('settleAccount.bankNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('settleAccount.bankCard')" prop="bankCard">
        <el-input v-model="accountForm.bankCard" :placeholder="$t('settleAccount.bankCardPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('settleAccount.bankAddress')">
        <el-input v-model="accountForm.bankAddress" :placeholder="$t('settleAccount.bankAddressPlaceholder')" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="saving" @click="handleSave">
          {{ $t('settleAccount.save') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { querySettleAccount, saveSettleAccount } from '@/api/fee/settleApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'settleAccountForm',
  data() {
    return {
      saving: false,
      communityId: '',
      accountForm: {
        storeName: '',
        ownerName: '',
        bankName: '',
        bankCard: '',
        bankAddress: ''
      },
      accountRules: {
        ownerName: [{ required: true, message: this.$t('settleAccount.ownerNameRequired'), trigger: 'blur' }],
        bankName: [{ required: true, message: this.$t('settleAccount.bankNameRequired'), trigger: 'blur' }],
        bankCard: [{ required: true, message: this.$t('settleAccount.bankCardRequired'), trigger: 'blur' }]
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._load()
  },
  methods: {
    _load() {
      querySettleAccount({ communityId: this.communityId }).then(res => {
        if (res.code === 0) {
          const data = res.data
          if (data) {
            this.accountForm = {
              storeName: data.storeName || '',
              ownerName: data.ownerName || '',
              bankName: data.bankName || '',
              bankCard: data.bankCard || '',
              bankAddress: data.bankAddress || ''
            }
          }
        }
      })
    },
    handleSave() {
      this.$refs.accountForm.validate(valid => {
        if (!valid) {
          return false
        }
        this.saving = true
        saveSettleAccount({
          communityId: this.communityId,
          ownerName: this.accountForm.ownerName,
          bankName: this.accountForm.bankName,
          bankCard: this.accountForm.bankCard,
          bankAddress: this.accountForm.bankAddress
        }).then(res => {
          this.saving = false
          if (res.code === 0) {
            this.$message.success(this.$t('settleAccount.saveSuccess'))
            this._load()
          } else {
            this.$message.error(res.msg || this.$t('settleAccount.saveFail'))
          }
        }).catch(() => {
          this.saving = false
        })
      })
    }
  }
}
</script>

<style scoped>
</style>
